import styled from 'styled-components';

export const Card = styled.a`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: ${(props) => props.theme.borderRadius[8]};
  transition: 0.3s ease;
  text-decoration: none;
  color: ${(props) => props.theme.color.neutral[100]};
  height: fit-content;

  img {
    object-fit: cover;
    border-radius: ${(props) => props.theme.borderRadius[8]};
    border: 1px solid ${(props) => props.theme.color.base_15};
    transition: border-radius 0.3s ease;

    @media ( max-width: ${(props) => props.theme.screen.lg} ) {
      width: 100%;
      max-width: 264px;
    }

    @media ( max-width: ${(props) => props.theme.screen.sm} ) {
      height: 72px;
      width: 128px;
    }

    @media ( max-width: ${(props) => props.theme.screen.xs} ) {
      height: 84px;
      width: 70%;
      min-width: 108px;
    }
  }

  :hover {
    background-color: ${(props) => props.theme.color.neutral[0]};
    box-shadow: ${(props) => props.theme.boxShadow.over_30};

    img {
      border-radius: ${({ theme: { borderRadius } }) => `${borderRadius[8]} ${borderRadius[8]} 0 0`};
    }
  }

  @media ( max-width: ${(props) => props.theme.screen.sm} ) {
    flex-direction: row;
  }
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing[8]};
  padding: ${({ theme: { spacing } }) => `${spacing[16]} ${spacing[16]} ${spacing[24]}`};
  width: 100%;

  h3 {
    font-weight: ${(props) => props.theme.typography.fontWeight.medium};
    font-size: ${(props) => props.theme.typography.fontSize[16]};
    line-height: 1.5;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    -webkit-line-clamp: 2;

    @media ( max-width: ${(props) => props.theme.screen.xs} ) {
      font-size: ${(props) => props.theme.typography.fontSize[14]};
      line-height: 1.4;
    }
  }

  @media ( max-width: ${(props) => props.theme.screen.xs} ) {
    height: 82px;
    justify-content: space-around;
    gap: ${(props) => props.theme.spacing[4]};
    padding: 0;
    padding-left: ${(props) => props.theme.spacing[12]};
  }
`;

export const Date = styled.div`
  font-size: ${(props) => props.theme.typography.fontSize[12]};
  font-weight: ${(props) => props.theme.typography.fontWeight.bold};
  text-transform: uppercase;

  div {
    color: ${(props) => props.theme.color.brand.pure};
  }
`;

export const Location = styled.p`
  font-size: ${(props) => props.theme.typography.fontSize[12]};
  color: ${(props) => props.theme.color.neutral[90]};

  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 1;
`;
